export default "/react/ozon-1a36b4ea.svg";